import React from 'react';
import styles from './HorizontalRule.pcss';

const HorizontalRule = () => <div className={styles.hr} />;

export default HorizontalRule;
